<div class="ui grid segment backgroundcolor zeroPaddingMargin"
     [ngStyle]="styles.main">
  <div class="ui column zeroPaddingMargin"
       [ngStyle]="styles.fixtureArea">
    <div class="ui grid segment zeroPaddingMargin" style="height:100%">
      <div class="ui sixteen wide column" [ngStyle]="styles.header">
        <headerTop (sportSelect)="sportSelected($event)"></headerTop>
      </div>
      <div class="ui sixteen wide column ScrollBar ScrollMarPad"
           id="scrollableContainer"
           [ngStyle]="styles.rows" style="scroll-behavior: smooth;">
        <liveFixtures *ngIf="isLive"></liveFixtures>
        <preFixture *ngIf="isPre"></preFixture>

      </div>
      <div class="ui sixteen wide column"
           [ngStyle]="styles.footer">
        <comp_livebetfooter></comp_livebetfooter>
      </div>
    </div>
  </div>
  <div class="ui column"
       [ngStyle]="styles.bettingSlip">
    <bettingSlip></bettingSlip>
  </div>
</div>
